import { type GetProjectDetailsResponse, USER_ROLES } from "@nlc/shared-types";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { projectDetailsKeys } from "@/hooks/queryKeys";
import { useUser } from "@/hooks/useUser";
import apiClient from "@/lib/api/client";

export function useGetProjectDetails(
  projectId: number,
): UseQueryResult<GetProjectDetailsResponse, Error> {
  const { data: user } = useUser();

  const shouldEnableQuery =
    user?.user?.roleName &&
    [
      USER_ROLES.ADMIN,
      USER_ROLES.CUSTOMER_SUCCESS,
      USER_ROLES.OWNER,
      USER_ROLES.SUPER_ADMIN,
      USER_ROLES.TEAM_LEADER,
    ].includes(user.user.roleName);

  return useQuery<GetProjectDetailsResponse>({
    enabled: Boolean(shouldEnableQuery && projectId),
    queryFn: async () =>
      await apiClient.url(`/projects/${projectId}/details`).get().json(),
    queryKey: projectDetailsKeys.detail(projectId),
    refetchOnWindowFocus: false,
    staleTime: 30_000,
  });
}
